"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var component_overlay_1 = __importDefault(require("@doordash/component-overlay"));
var App_1 = require("../App");
var enums_1 = require("../Common/utils/enums");
var useTracking_1 = __importDefault(require("../Common/utils/useTracking"));
var i18n_1 = __importDefault(require("../i18n"));
/* tslint:disable:max-line-length */
var ThreeDSecureVerifyMutation_1 = __importDefault(require("./Providers/ThreeDSecureVerifyMutation"));
var styles_1 = require("./styles");
var ThreeDSecureContext_1 = __importDefault(require("./ThreeDSecureContext"));
var PaymentIntentStatusType = {
    REQUIRES_CONFIRMATION: 'requires_confirmation',
    CANCELED: 'canceled'
};
var ExceptionReasons = {
    HANDLE_CARD_ACTION__ERROR: 'HANDLE_CARD_ACTION__ERROR',
    CANCELED: 'CANCELED',
    UNKNOWN: 'UNKNOWN',
    EXCEPTION: 'EXCEPTION'
};
var ThreeDSecureAuthView = function () {
    var _a = React.useContext(App_1.RiskContext), dispatch = _a.dispatch, state = _a.state;
    var _b = React.useContext(ThreeDSecureContext_1["default"]), cartId = _b.cartId, threeDSecureClientSecret = _b.threeDSecureClientSecret, stripeKey = _b.stripeKey;
    var threeDSecureVerify = ThreeDSecureVerifyMutation_1["default"]().threeDSecureVerify;
    var _c = useTracking_1["default"](), trackFailure = _c.trackFailure, trackSuccess = _c.trackSuccess;
    var stripe = React.useMemo(function () { return window.Stripe(stripeKey, { locale: i18n_1["default"].language }); }, [cartId]);
    var handleCardAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, handleCardActionError, paymentIntent, _b, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 11, , 12]);
                    return [4 /*yield*/, stripe.handleCardAction(threeDSecureClientSecret)];
                case 1:
                    _a = _c.sent(), handleCardActionError = _a.error, paymentIntent = _a.paymentIntent;
                    if (!handleCardActionError) return [3 /*break*/, 3];
                    trackFailure({
                        orderCartId: cartId,
                        reason: ExceptionReasons.HANDLE_CARD_ACTION__ERROR,
                        message: handleCardActionError.message
                    });
                    return [4 /*yield*/, threeDSecureVerify('FAILED')];
                case 2:
                    _c.sent();
                    dispatch({ type: enums_1.RiskActions.Reset });
                    return [3 /*break*/, 10];
                case 3:
                    if (!paymentIntent) return [3 /*break*/, 10];
                    _b = paymentIntent.status;
                    switch (_b) {
                        case PaymentIntentStatusType.REQUIRES_CONFIRMATION: return [3 /*break*/, 4];
                        case PaymentIntentStatusType.CANCELED: return [3 /*break*/, 6];
                    }
                    return [3 /*break*/, 8];
                case 4:
                    trackSuccess(cartId);
                    return [4 /*yield*/, threeDSecureVerify('SUCCEEDED')];
                case 5:
                    _c.sent();
                    dispatch({ type: enums_1.RiskActions.Reset });
                    if (state.onSuccess) {
                        state.onSuccess();
                    }
                    return [3 /*break*/, 10];
                case 6:
                    trackFailure({
                        orderCartId: cartId,
                        reason: ExceptionReasons.CANCELED
                    });
                    return [4 /*yield*/, threeDSecureVerify('CANCELED')];
                case 7:
                    _c.sent();
                    dispatch({ type: enums_1.RiskActions.Reset });
                    return [3 /*break*/, 10];
                case 8:
                    trackFailure({
                        orderCartId: cartId,
                        reason: ExceptionReasons.UNKNOWN,
                        message: "Unexpected payment intent status: " + paymentIntent.status
                    });
                    return [4 /*yield*/, threeDSecureVerify('UNKNOWN')];
                case 9:
                    _c.sent();
                    dispatch({ type: enums_1.RiskActions.Reset });
                    _c.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    err_1 = _c.sent();
                    trackFailure({
                        orderCartId: cartId,
                        reason: ExceptionReasons.EXCEPTION
                    });
                    dispatch({ type: enums_1.RiskActions.Reset });
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var memoizedHandleCardAction = React.useCallback(handleCardAction, [cartId]);
    React.useEffect(function () {
        memoizedHandleCardAction();
    }, [cartId]);
    return (React.createElement(styles_1.AuthViewBackdrop, null,
        React.createElement(component_overlay_1["default"], { isVisible: true, type: component_overlay_1["default"].Types.Loading })));
};
exports["default"] = ThreeDSecureAuthView;
